<template>
	<div>
		<p style="opacity: 70%;">
			操作提示：点击图中设备以查看详细信息
		</p>
		<el-dialog
			title="主变压器"
			:visible.sync="gsuVisible"
			width="40%"
		>
			<span>
				<img src="../assets/gsu.jpg" height="200px">
				<p style="text-align: left; text-indent: 28px;">
					主变压器，简称主变（GSU），是一个单位或变电站中主要用于输变电的总降压变压器，也是变电站的核心部分。变压器是电力机车牵引供电系统的核心设备, 也是保证牵引供电系统安全稳定运行的关键设备。
				</p>
				<p style="text-align: left; text-indent: 28px;">
					主变压器的容量一般比较大，并且要求工作的可靠性高。尽管主变压器故障率不高，但是一旦出现故障就会造成重大的损失。轻则可能会造成设备故障；重则会引发火情，危及正常的运输安全。因此，分析变压器的故障原因，并采取相应的防范措施具有非常重要的意义。
				</p>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="gsuVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="断路器"
			:visible.sync="cbVisible"
			width="40%"
		>
			<span>
				<img src="../assets/cb.jpg" height="200px	">
				<p style="text-align: left; text-indent: 28px;">
					断路器（英语：Circuit Breaker，简称CB），广泛使用于工业生产和日常生活中，主要功能是合上和断开回路（ON/OFF POWER）。别名:空气开关、保险掣、无熔丝开关。断路器会在短路和严重超载的情况下切断电路，从而有效的保护回路中的电器。
				</p>
				<p style="text-align: left; text-indent: 28px;">
					高压用断路器，最常见为气体断路器和真空断路器，35kV及以下电力系统中，多采用真空断路器；35kV以上电力系统则多采用气体断路器（SF6断路器）。
				</p>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="cbVisible = false">确 定</el-button>
			</span>
		</el-dialog>
			<el-dialog
			title="隔离开关"
			:visible.sync="lsVisible"
			width="40%"
		>
			<span>
				<img src="../assets/ls.jpg" height="200px">
				<p style="text-align: left; text-indent: 28px;">
					隔离开关（Isolating switch）是一种主要用于“隔离电源、倒闸操作、用以连通和切断小电流电路”，无灭弧功能的开关器件。隔离开关在分位置时，触头间有符合规定要求的绝缘距离和明显的断开标志；在合位置时，能承载正常回路条件下的电流及在规定时间内异常条件（例如短路）下的电流的开关设备。
				</p>
				<p style="text-align: left; text-indent: 28px;">
					一般用作高压隔离开关，即额定电压在1kV以上的隔离开关，它本身的工作原理及结构比较简单，但是由于使用量大，工作可靠性要求高，对变电所、电厂的设计、建立和安全运行的影响均较大。隔离开关的主要特点是无灭弧能力，只能在没有负荷电流的情况下分、合电路。
				</p>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="lsVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<div style="transform: translateX(0px); width: 850px; height: 600px; margin: 0 auto;">
			<img src="../assets/device.svg" style="border: 1px solid;" height="600px" width="850px">
			<div 
				style="position: absolute; left: 153px; bottom: 296px; width: 15px; height: 37px; border: 1px solid;"
				@mouseenter="focus_cb = true" @mouseleave="focus_cb = false"
				:class="{ select: focus_cb }"
				@click="cbVisible = true"
			></div>
			<div 
				style="position: absolute; left: 326.5px; bottom: 271px; width: 15px; height: 37px; border: 1px solid;"
				@mouseenter="focus_cb = true" @mouseleave="focus_cb = false"
				:class="{ select: focus_cb }"
				@click="cbVisible = true"
			></div>
			<div 
				style="position: absolute; left: 542.5px; bottom: 271px; width: 15px; height: 37px; border: 1px solid;"
				@mouseenter="focus_cb = true" @mouseleave="focus_cb = false"
				:class="{ select: focus_cb }"
				@click="cbVisible = true"
			></div>
			<div 
				style="position: absolute; right: 114.5px; bottom: 296px; width: 15px; height: 37px; border: 1px solid;"
				@mouseenter="focus_cb = true" @mouseleave="focus_cb = false"
				:class="{ select: focus_cb }"
				@click="cbVisible = true"
			></div>
			<div 
				style="position: absolute; left: 374px; top: 213px; width: 23px; height: 23px; border: 1px solid;"
				@mouseenter="focus_gsu = true" @mouseleave="focus_gsu = false"
				:class="{ select: focus_gsu }"
				@click="gsuVisible = true"
			></div>
			<div 
				style="position: absolute; left: 493px; top: 213px; width: 23px; height: 23px; border: 1px solid;"
				@mouseenter="focus_gsu = true" @mouseleave="focus_gsu = false"
				:class="{ select: focus_gsu }"
				@click="gsuVisible = true"
			></div>
			<div 
				style="position: absolute; left: 380px; top: 172px; width: 10px; height: 20px; border: 1px solid;"
				@mouseenter="focus_ls = true" @mouseleave="focus_ls = false"
				:class="{ select: focus_ls }"
				@click="lsVisible = true"
			></div>
			<div 
				style="position: absolute; left: 404px; top: 172px; width: 10px; height: 20px; border: 1px solid;"
				@mouseenter="focus_ls = true" @mouseleave="focus_ls = false"
				:class="{ select: focus_ls }"
				@click="lsVisible = true"
			></div>
			<div 
				style="position: absolute; left: 500px; top: 172px; width: 10px; height: 20px; border: 1px solid;"
				@mouseenter="focus_ls = true" @mouseleave="focus_ls = false"
				:class="{ select: focus_ls }"
				@click="lsVisible = true"
			></div>
			<div 
				style="position: absolute; left: 522px; top: 172px; width: 10px; height: 20px; border: 1px solid;"
				@mouseenter="focus_ls = true" @mouseleave="focus_ls = false"
				:class="{ select: focus_ls }"
				@click="lsVisible = true"
			></div>
			<div 
				style="position: absolute; left: 382px; top: 140px; width: 10px; height: 20px; border: 1px solid;"
				@mouseenter="focus_cb = true" @mouseleave="focus_cb = false"
				:class="{ select: focus_cb }"
				@click="cbVisible = true"
			></div>
			<div 
				style="position: absolute; left: 501px; top: 140px; width: 10px; height: 20px; border: 1px solid;"
				@mouseenter="focus_cb = true" @mouseleave="focus_cb = false"
				:class="{ select: focus_cb }"
				@click="cbVisible = true"
			></div>
		</div>
		<!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
	</div>
</template>
<script>

export default {
	data() {
		return {
			input: " ",
			focus_gsu: false,
			focus_cb: false,
			focus_ls: false,
			gsuVisible: false,
			cbVisible: false,
			lsVisible: false
		}
	}
}
</script>

<style>
.select {
	background-color: rgba(102, 204, 255, 0.5); 
}
</style>

